import moment from "moment";
import { stringFormattingToCurrency } from "./stringFormattingToCurrency";
import { isAnnuityPolicy, isOldAlicUlPolicy } from "js/utilities";

export const getBadgeText = (selectedPolicy) => {
  const status = selectedPolicy?.status;
  const costOfInsuranceDueDate =
    selectedPolicy?.costOfInsurance?.costOfInsuranceDueDate;
  const isAnnuityType = isAnnuityPolicy(selectedPolicy);
  const isULPolicy = isOldAlicUlPolicy(selectedPolicy);
  const dueDate = isULPolicy
    ? moment(selectedPolicy?.costOfInsurance?.costOfInsuranceDueDate)
    : moment(selectedPolicy?.premiumDueDate);
  const isDueDateBeforeNow = dueDate.isBefore(moment(), "day");
  const modalPremiumAmountTotal = selectedPolicy?.modalPremiumAmountTotal;

  switch (status?.toLowerCase()) {
    default:
    case "":
    case "active":
    case "reinstated":
      if (isULPolicy && !costOfInsuranceDueDate) {
        return selectedPolicy?.graceFlag?.toLowerCase() === "y"
          ? "In Grace"
          : "Active";
      }
      if (isAnnuityType) {
        return "Active";
      }
      return isDueDateBeforeNow
        ? isULPolicy
          ? "In Grace"
          : `${stringFormattingToCurrency(modalPremiumAmountTotal)} Past Due`
        : "Active";
    case "paid-up":
    case "reducedpaidup":
    case "extended term":
      return "Active";
    case "terminated":
    case "cancelled":
    case "surrendered":
    case "expired":
    case "administrative rewrite":
    case "matured":
    case "lapsed":
    case "deceased":
      return "Terminated";
    case "term conversion":
      return "Terminated Due to Conversion";
    case "conditionally issued":
      return "Conditionally Issued";
    case "declined":
      return "Declined";
  }
};
